module.exports = __webpack_public_path__ + "static/img/case2.99fda4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case2.png
// module id = afLx
// module chunks = 1